import React, { Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import { fieldExistsOnPlayType, getInputError } from "games/utils";
import { isDisplayable } from "util/misc";

const PlayNumberInput = ({
  inputName,
  label,
  handleInputChange,
  play,
  classes,
  tabIndex
}) => {
  const error = getInputError(inputName, play[inputName]);
  const formatValue = (val) => {
    return isDisplayable(val) ? val : "";
  };

  return (
    <Fragment>
      {fieldExistsOnPlayType(play.playType, inputName) && (
        <TextField
          error={error.isError}
          id={inputName}
          type="number"
          label={label}
          onChange={(event) => handleInputChange(event, inputName)}
          value={formatValue(play[inputName])}
          variant="filled"
          className={classes.input}
          helperText={error.message}
          InputProps={
            tabIndex || tabIndex === 0 ? { inputProps: { tabIndex } } : {}
          }
        />
      )}
    </Fragment>
  );
};

export default PlayNumberInput;
